import type { Icons } from '@Components/icon/Icon.tsx';
import type { ReactNode, ReactElement } from 'react';

export enum ModalTypes {
  GENERAL = 'GENERAL',
  CUSTOM = 'CUSTOM',
  NONE = 'NONE',
}

export interface InitialState {
  isActive: boolean;
  type: ModalTypes;
  icon: Icons;
  title?: string;
  content?: string;
  buttonText?: string;
  button2Text?: string;
  customComponent?: ReactElement;
  blur?: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  persistModal?: boolean;
}

export enum ModalActions {
  SET_MODAL = 'SET_MODAL',
}

export interface ModalAction {
  type: ModalActions.SET_MODAL;
  payload: Partial<InitialState>;
}

export interface ModalProviderProps {
  children: ReactNode;
}
